import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

export function RequireAdmin({ children, moduleKey, action, anyPermissions, superAdminOnly = false }) {
  const { user, hasPerm } = useAuth();
  if (!user || user.accountType !== 'admin') return <Navigate to="/admin/login" replace />;
  if (!user.role) {
    return (
      <div className="p-10 text-center">
        <h2 className="font-heading text-2xl text-primaryDark mb-2">Role Required</h2>
        <p className="text-primaryDark/70">Ask a Super Admin to assign a role to this account.</p>
      </div>
    );
  }
  if (superAdminOnly && !user.role?.isSystem) {
    return (
      <div className="p-10 text-center">
        <h2 className="font-heading text-2xl text-primaryDark mb-2">Super Admin Only</h2>
        <p className="text-primaryDark/70">This system section requires full-control access.</p>
      </div>
    );
  }
  if (anyPermissions?.length && !anyPermissions.some(([key, requiredAction]) => hasPerm(key, requiredAction))) {
    return (
      <div className="p-10 text-center">
        <h2 className="font-heading text-2xl text-primaryDark mb-2">Access Restricted</h2>
        <p className="text-primaryDark/70">You do not have permission to view this section.</p>
      </div>
    );
  }
  if (moduleKey && action && !hasPerm(moduleKey, action)) {
    return (
      <div className="p-10 text-center">
        <h2 className="font-heading text-2xl text-primaryDark mb-2">Access Restricted</h2>
        <p className="text-primaryDark/70">You do not have permission to view this section.</p>
      </div>
    );
  }
  return children;
}
